"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const tabletContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Kenapa Banyak yang Beralih ke Sewa Tablet Terdekat?</h2>

    <p className="mb-4">
      Zaman berubah. Gak semua hal perlu dibeli. Ketika efisiensi dan kecepatan adalah segalanya, <strong>sewa tablet terdekat</strong> jadi pilihan cerdasbukan karena tidak mampu beli, tapi karena tahu persis mana yang lebih menguntungkan. Dari <strong>tablet Android</strong> hingga <strong>drawing tablet</strong> profesional, dari event branding hingga workshop edukatif semua jadi mudah dijangkau, cukup dengan sewa.
    </p>

    <ul className="space-y-6 mb-6">
      <li className="bg-white shadow-xl rounded-2xl p-5 border border-gray-200 hover:shadow-2xl transition-all">
        <h4 className="font-semibold text-lg mb-2">Tablet Sesuai Spek & Tipe yang Dibutuhkan</h4>
        <p className="text-sm leading-relaxed">
          Butuh iPad buat desain grafis? Atau Android untuk survei lapangan? Kami siapkan semua tipe dan brand: <strong> Samsung, Huawei, iPad Pro, hingga XP-Pen</strong>. Tinggal pilih, <strong>sewa tablet terdekat</strong> langsung jalan. Gak perlu beli, gak perlu tunggu.
        </p>
      </li>

      <li className="bg-white shadow-xl rounded-2xl p-5 border border-gray-200 hover:shadow-2xl transition-all">
        <h4 className="font-semibold text-lg mb-2">Harga Sewa Tablet Terdekat yang Luwes</h4>
        <p className="text-sm leading-relaxed">
          Sewa harian untuk event 1 hari? Mingguan buat pelatihan? Atau bulanan untuk kebutuhan perusahaan? Semua fleksibel. <strong>Harga sewa tablet terdekat</strong> kami menyesuaikan brand, spesifikasi, dan durasi sewa. Hemat, jelas, tanpa biaya² tersembunyi.
        </p>
      </li>

      <li className="bg-white shadow-xl rounded-2xl p-5 border border-gray-200 hover:shadow-2xl transition-all">
        <h4 className="font-semibold text-lg mb-2">Unit Terawat & Siap Pakai</h4>
        <p className="text-sm leading-relaxed">
          Setiap unit dalam kondisi prima. Sudah update OS terbaru, factory reset, tanpa akun terkunci. <strong> Drawing tablet </strong> kami juga include stylus dengan pen pressure sensitivity, charger, dan driver. Kamu tinggal pakai, gak pakai ribet.
        </p>
      </li>

      <li className="bg-white shadow-xl rounded-2xl p-5 border border-gray-200 hover:shadow-2xl transition-all">
        <h4 className="font-semibold text-lg mb-2">Pengiriman Cepat, Dukungan Area Lokal</h4>
        <p className="text-sm leading-relaxed">
          Butuh tablet mendadak? Kami bisa kirim <strong>sewa tablet terdekat</strong> hari ini jugalangsung ke lokasi kamu. Termasuk setup WiFi, akun, dan install aplikasi sesuai kebutuhan. Kami bantu sampai siap pakai.
        </p>
      </li>

      <li className="bg-white shadow-xl rounded-2xl p-5 border border-gray-200 hover:shadow-2xl transition-all">
        <h4 className="font-semibold text-lg mb-2">Kebutuhan Apapun? Bisa</h4>
        <p className="text-sm leading-relaxed">
          Dari kebutuhan personal seperti nonton, belajar, digital drawing hingga kebutuhan profesional seperti event branding, booth interaktif, pelatihan guru, input data survei. <strong>Sewa tablet terdekat</strong> siap melayani satuan maupun puluhan unit.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Tablet Tidak Lagi untuk Dimiliki. Tapi Dimanfaatkan.</h2>
    <p className="mb-4">
      Dunia bergerak cepat. Kamu bukan sedang mencari tablet, kamu sedang mencari <em>solusi</em>. Dan solusi itu bukan di toko besar, tapi di <strong>sewa tablet terdekat</strong>. Fleksibel, efisien, tanpa beban after-sales. Mulai sekarang, kamu tidak lagi beli tapi mengoptimalkan.
    </p>

    <h2 className="text-xl font-bold mb-3">Sewa Bukan Alternatif. Ini Strategi.</h2>
    <p className="mb-4">
      Strategi hemat budget. Strategi efisiensi logistik. Strategi go digital tanpa investasi besar. <strong> Sewa tablet terdekat </strong> bukan rencana cadangan. Ini adalah langkah taktis bagi tim kreatif, marketer, guru, content creator, dan penyelenggara event yang ingin bergerak cepat.
    </p>

    <h2 className="text-xl font-bold mb-3">Mulai Sekarang. Tanpa Nunggu-nunggu.</h2>
    <p className="mb-4">
      Semakin lama kamu tunda, semakin besar potensi kamu terbuang. Hubungi kami, dan <strong>sewa tablet terdekat</strong> langsung jalan hari ini. Karena kadang, satu tablet bisa jadi pemicu perubahan besar dalam bisnismu.
    </p>

    <CTA
      title="Siap Keren Kemana² Bosku?"
      description="🚚 Butuh sewa tablet terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Tablet Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20tablet.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Tablet"
    />


  </>
);